<div class="p-3 w-100">
  <div class="d-flex justify-content-start align-items-center">
    <img
      fetchpriority="high"
      width="136"
      height="90"
      src="images/ai-kosh-logo.svg"
      alt="AIKosh"
      title="AIKosh"
      class="ms-auto me-auto"
    />
  </div>
</div>

<div class="p-4 main-container">
  <div class="form-container">
    <div class="mb-4">
      <h1 class="text-2xl fw-600 mb-2">Let's confirm your details</h1>
      <p class="detail-desc mb-0">
        We noticed a difference between your existing AIKosh account and your
        new Jan Parichay login. Choose the details you want to keep.
      </p>
    </div>

    <!-- Phone Confirmed Section -->
    <div class="phone-confirmed-section p-4 mb-4">
      <div class="d-flex align-items-center gap-3">
        <div class="status-badge success">
          <img src="images/success.svg" height="100%" width="100%" alt="" />
        </div>
        <div class="flex-grow-1">
          <h3 class="text-base fw-600 mb-2 text-green">Phone Confirmed</h3>
          <p class="detail-desc mb-0">
            Your phone <strong>{{ userDetails?.phone }}</strong> matches on both
            platforms. Only the email differs.
          </p>
        </div>
      </div>
    </div>

    <!-- Email Selection Section -->
    <form [formGroup]="emailSelectionForm">
      <div class="card-container p-4">
        <h3 class="text-base fw-600 mb-4">Select email to continue with</h3>

        <div class="email-options mb-4">
          @for (emailOption of multipleEmails; track emailOption.email) {
            <div
              class="email-option"
              [class.selected]="selectedEmail?.email === emailOption.email"
              (click)="onEmailSelection(emailOption)"
            >
              <app-radio-input
                name="emailSelection"
                [inputId]="emailOption.email"
                [value]="emailOption.email"
                [control]="selectedEmailControl"
                (change)="onEmailSelection(emailOption)"
              >
                <div class="fw-600">{{ emailOption.email }}</div>
                <div class="provider-label text-sm text__gray">
                  from your {{ emailOption.provider }} Account
                </div>
              </app-radio-input>
            </div>
          }
        </div>
      </div>
    </form>

    <!-- Confirmation Checkbox -->
    <div class="pt-3 my-4">
      <app-checkbox-input
        inputId="confirmSelection"
        [control]="isConfirmedControl"
      >
        I understand that the removed details cannot be recovered, and I want to
        proceed with my selection above.
      </app-checkbox-input>
    </div>

    <!-- Action Buttons -->
    <button
      class="form-button btn-confirm"
      type="button"
      (click)="onConfirmSelection()"
      [disabled]="!emailSelectionForm.valid"
    >
      Confirm & Complete Migration
    </button>

    @if (userDetails?.isLoggedInUser) {
      <button
        class="form-button btn-skip mt-3"
        type="button"
        (click)="onSkipSelection()"
      >
        Skip for Now
      </button>
    }

    <!-- FAQ Link -->
    <div class="text-center mt-4">
      <p class="text-sm">
        Having trouble?
        <a
          [routerLink]="['/', routes.home, routes.faqs]"
          class="text__green view-faq"
          >View FAQ</a
        >
      </p>
    </div>
  </div>
</div>
